export default __webpack_public_path__ + "static/media/leaflte-icon.d32882f2.svg";